/**
 * Adicionales
 *
 */
import React from 'react'
import { Table, Button, Modal, InputNumber, message} from 'antd'
import Api from '../../../Api'
import Exception from '../../../Exception'
import Crud from '../../../components/Crud'
import numeral from 'numeral'

export default class PrecioAdicionales extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    this.state = {
      data: [],
      columns: [],
      loading: false,
      precioId: -2,
      comparativaId: -2,
      cotizacionPendiente: false,
    }

    this.columns = [
      { key: 'nombre', title: 'DESCRIPCIÓN', width: '70%', dataIndex: 'nombre' },
      { key: 'precio', title: 'PRECIO UNITARIO', width: '30%', dataIndex: 'precioAdicional.dPrecio', render: (val, record) => (
        <div>
          {!this.state.cotizacionPendiente ? numeral(val).format('$0,0.0000') : (
            <InputNumber
              size='small'
              value={val ? val.toString() : '0'}
              precision={4}
              onChange={val => this.setState({
                data: this.state.data.map(
                  current => current.iId !== record.iId ? current : ({
                    ...current,
                    precioAdicional: {
                      ...record.precioAdicional,
                      dPrecio: val > 0 ? val : 0,
                    },
                    changed: true,
                  })
                )
              })}
            />
          )}
        </div>
      )},
    ]
  }

  /**
   * Load
   *
   * @param {Number} comparativaId
   * @param {Number} precioId
   */
  load = (comparativaId, precioId) => {
    this.setState({
      comparativaId,
      precioId,
      visible: true,
      loading: true,
      data: [],
      sobreCostos: [],
    })

    const query = {
      firmas: {
        model: 'ComCuadroComparativoFirma',
        attributes: ['iId'],
        where: {
          iIdCuadro: comparativaId,
          iIdUsuario: { $gt: 0 },
          iActivo: true,
        },
        limit: 1,
      },

      sobreCostos: {
        model: 'AlmSobrecosto',
        attributes: ['iId', ['sDescripcion', 'nombre']],
        include: [{
          as: 'precioAdicional',
          required: false,
          attributes: ['iId', 'dPrecio'],
          where: {
            iIdPrecio: precioId,
            iActivo: true,
          }
        }],
        where: {
          iActivo: true,
        }
      }
    }

    Api.query.list(query)
      .then(response =>
        this.setState({
          loading: false,
          data: response.data.sobreCostos,
          cotizacionPendiente: response.data.firmas.length === 0,
        })
      )
      .catch(error => {
        this.setState({ loading: false })
        Exception.load(error).show()
      })
  }

  /**
   * saveAll
   */
  saveAll = (callback) => {
    this.setState({ loading: true })

    const items = this.state.data
      .filter(item => item.changed)
      .map(item =>
        ({
          iIdTipo: 1,
          iIdSobreCosto: item.iId,
          iIdImpuesto: null,
          dPrecio: item.precioAdicional.dPrecio
        })
      )

    if (items.length) {
      Api.post(`/com/cotizaciones/precios/${this.state.precioId}/adicionales`, { items })
      .then(() => {
        this.setState({ loading: false })
        message.success('Datos guardados')
        callback && callback()
      })
      .catch(error => {
        Exception.load(error).show()
        this.setState({ loading: false })
      })
    } else {
      this.setState({ loading: false })
    }
  }

  /**
   * Render
   *
   */
  render() {
    const crud = (
      <Crud
        buttons={['reload']}
        onReload={() => this.load(this.state.precioId)}
        onAdd={this.nuevoAdjunto}
      />
    )

    return (
      <Modal
        title='ADICIONALES'
        visible={this.state.visible}
        onOk={this.onSave}
        style={{ minWidth: '60%' }}
        onCancel={() => this.setState({ visible: false })}
        footer={[
          <Button
            key='close'
            loading={this.state.loading}
            onClick={() => this.setState({ visible: false })}
            children='CANCELAR'
          />,
          <Button
            key='save'
            type='primary'
            loading={this.state.loading}
            onClick={() =>
              this.saveAll(() => this.setState({ visible: false }))
            }
            children='GUARDAR'
          />
        ]}
        children={
          <Table
            key='2'
            rowKey='iId'
            size='small'
            loading={this.state.loading}
            columns={this.columns}
            pagination={false}
            dataSource={this.state.data}
            bordered={false}
            title={() => (
              <div>{crud}</div>
            )}
          />
        }
      />
    )
  }
}
